import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { resetAuthenticator } from './Manage2faEndpoints';
import { Manage2faAuthenticatorDisableAppDialog } from './Manage2faAuthenticatorDisableAppDialog';

export const Manage2faAuthenticatorResetAppDialog = (props) => {
    const { open, onConfirm, onClose } = props;
    const [openDisableAuthApp, setOpenDisableAuthApp] = React.useState(false);

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = async (triggerSetup) => {
        await resetAuthenticator();
        onConfirm(triggerSetup);
    };

    const handleDisable = () => {
        setOpenDisableAuthApp(true);
    };

    const handleDisableAuthenticatorClose = () => {
        setOpenDisableAuthApp(false);
    };

    return (
        <>
            <Manage2faAuthenticatorDisableAppDialog
                open={openDisableAuthApp}
                onClose={handleDisableAuthenticatorClose}
                closeConfigureDialog={handleClose}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"If you reset your authenticator key your authenticator app will not work until you reconfigure it"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This process disables MFA until you verify your authenticator app.
                        If you do not complete your authenticator app configuration you may lose access to your account.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="primary" onClick={handleClose} autoFocus>Cancel</Button>
                    <Button variant='contained' color="error" onClick={() => handleDisable()}>
                        {'Disable Auth App'}
                    </Button>
                    <Button variant='contained' color="warning" onClick={() => handleConfirm(true)}>
                        {'Reset & Reconfigure'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}